import React from 'react';
import Modal from 'react-modal';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqAbstractAccessModal = function RubriqAbstractAccessModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: open,
    overlayClassName: "react-modal-overlay",
    className: "react-modal modal-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: onClose,
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Account access"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center flex-shrink-0 me-3",
    style: {
      width: 38,
      height: 38,
      border: '2px solid #00a99d',
      borderRadius: '50%',
      color: '#00a99d',
      fontSize: 22,
      fontWeight: 600
    }
  }, "!"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T, {
    source: "abstract-no-access-popup"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: function onClick() {
      window.location.href = '/rubriq/plan';
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "upgrade-now"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))));
};
export default RubriqAbstractAccessModal;